module.exports = __webpack_public_path__ + "/aed48fbef19b3ec6af0ecd7f182b84d1.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/signature-modal/loading-spinner-16.gif
 ** module id = 811
 ** module chunks = 0 1
 **/